import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getTaskById } from '@blade/common/api/bulk-import';
let default_1 = class default_1 extends Vue {
    detail = {};
    taskId;
    getData() {
        if (!this.taskId)
            return;
        getTaskById(this.taskId)
            .then((re) => {
            this.detail = re.data.data;
        })
            .catch((error) => {
            this.$message.error(error?.data?.message || this.$t('common.unknownError'));
        });
    }
    handleState() {
        return `<span>${this.$t('stateProcessing')}</span>`;
    }
    mounted() {
        this.getData();
    }
    onTaskIdChange(newVal) {
        console.log('newVal:', newVal);
        this.getData();
    }
};
__decorate([
    Prop()
], default_1.prototype, "taskId", void 0);
__decorate([
    Watch('taskId', { immediate: true })
], default_1.prototype, "onTaskIdChange", null);
default_1 = __decorate([
    Component({
        name: 'PhotoTableHeader',
        i18n: {
            messages: {
                'en-us': {
                    accountList: 'Account List',
                    exportCsv: 'Export Excel',
                    create: 'Create',
                    fileName: 'Portrait Name:',
                    state: 'State:',
                    creatorName: 'Create Name:',
                    updateTime: 'Updated Time:',
                    picNum: 'Vaild Portrait/Total Portrait:',
                    stateProcessFail: 'Fail：',
                    stateProcessSuccess: 'Success：',
                },
                zh: {
                    accountList: '账户列表',
                    exportCsv: '导出Csv',
                    create: '创建账户',
                    fileName: '人像包名称:',
                    state: '状态 ',
                    creatorName: '创建人:',
                    updateTime: '更新时间:',
                    picNum: '有效人像/总人像:',
                    stateProcessing: '处理中',
                },
            },
        },
    })
], default_1);
export default default_1;
